import DownloadLogsFileData from "./DownloadLogsFileData";

export default [
	{ title: 'File name', field: 'req_json', component: DownloadLogsFileData},
	{ title: 'Created at', field: 'created_at' },
	{ title: 'Updated at', field: 'updated_at' },
];